const ON_CHANGE_DEBOUNCE_TIMER=300,PUB_SUB_EVENTS={cartUpdate:"cart-update",quantityUpdate:"quantity-update",variantChange:"variant-change",cartError:"cart-error"};
//# sourceMappingURL=/s/files/1/0779/7430/7152/t/13/assets/constants.js.map?v=1699725772
